// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Observable } from 'rxjs'
import { errorAction } from '~/redux/commonActions'
import { ACTION_WEBSKED_COLLECTIONS_ADD, getCollections } from '../websked'

export default (action$, store, { serviceResolver }) =>
  action$
    .ofType(ACTION_WEBSKED_COLLECTIONS_ADD)
    .mergeMap((action) => {
      const thirdPartyIntegrationService = serviceResolver(
        'thirdPartyIntegrationService'
      )
      const width = window.innerWidth * 0.8 || 600
      const height = window.innerHeight - 10 || 580
      return Observable.from(
        thirdPartyIntegrationService(
          // Note this won't work for local env as for now we don't have an endpoint to proxy yet.
          // Will set it once it's available; before that please spin up a local collection instance for development.
          `/websked/collections/iframe/contents/${action.payload}`,
          ['esc', 'done'],
          [width, height],
          {
            className: 'collections-iframe',
          }
        )
      )
        .map((_) => {
          return getCollections(action.payload)
        })
        .catch((error) => Observable.of(errorAction(error)))
    })
    .filter((action) => !!action)
